
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppPlayerResourcesSupplementsListIndex} from "@/models/app/player/resources/supplements/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppPlayerResourcesSupplementsListFormLookupIndexVue from "@/views/app/player/resources/supplements/list/form/lookup.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppPlayerResourcesSupplementsListFormLookupIndexVue,
  },
})
export default class AppPlayerResourcesSupplementsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  supplements: Array<AppPlayerResourcesSupplementsListIndex> = [];

  async getSupplements(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/supplements`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.supplements = r.data.sort(function (a, b) {
          if (a.content.name < b.content.name) {
            return -1;
          }
          if (a.content.name > b.content.name) {
            return 1;
          }
          return 0;
        });
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getSupplements();
  }
}
